<template>
  <v-container fluid class="pa-0">
    <div class="product-banner">
      <v-row align="center" justify="center">
        <v-col class="text-center py-4 px-2 mt-15" cols="11">
          <div class="text-h4 font-weight-bold ">
            {{ blog.title | capitalize }}
          </div>
        </v-col>
        <v-col cols="auto" class="d-flex subtitle-1 align-center">
          <v-icon size="25" color="white">
            mdi-clock-outline
          </v-icon>
          <div class=" mx-2">{{ blog.add_date }}</div>
        </v-col>
        <v-col cols="auto" class="d-flex subtitle-1  align-center">
          <v-icon size="25" color="white">
            mdi-comment-outline
          </v-icon>
          <div class=" mx-2">{{ blog.blog_comments_count }} {{ $t('comment') | capitalize }}</div>
        </v-col>
      </v-row>
    </div>
    <v-container class="my-2">
      <v-row align="center">
        <v-col cols="12" class="my-10">
          <div class="subtitle-1" v-html="blog.description" />
        </v-col>
      </v-row>


      <v-divider class="my-5"></v-divider>



      <v-row justify="center" justify-md="start">
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            {{ $t('latest articles') | capitalize }}
          </div>
        </v-col>
        <v-col cols="11" sm="6" :md="6" :lg="4" v-for="(blog, index) in blogs" :key="index">
          <v-card class="pa-3 blog-card overflow-hidden position-relative gray-border"
            @click="$router.push(`/blogs/${blog.title}/${blog.id}`)" flat>
            <div class="absolute-center-x light">
              <v-img contain :lazy-src="$store.state.endpointURL + blog.image" height="210"
                class="rounded-lg  overflow-hidden d-block ma-auto" :src="$store.state.endpointURL + blog.image">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
                    <v-skeleton-loader class="mx-auto" max-width="320" type="image"></v-skeleton-loader>
                  </v-row>
                </template>
                <template v-slot:default>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
                    <v-skeleton-loader class="mx-auto" max-width="320" type="image"></v-skeleton-loader>
                  </v-row>
                </template>
              </v-img>
            </div>

            <v-card-title class="text-h6 title position-relative primary--text" style="margin-top: 150px;">
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
              {{ blog.title }}
            </v-card-title>
            <v-row justify="space-between" class="mt-2">
              <v-col cols="auto" class="d-flex align-center">
                <v-icon size="19">
                  mdi-clock-outline
                </v-icon>
                <div class="caption mx-2">{{ blog.add_date }}</div>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-icon size="19">
                  mdi-comment-outline
                </v-icon>
                <div class="caption mx-2">{{ blog.blog_comments_count }} {{ $t('comment') | capitalize }}</div>
              </v-col>
              <v-col cols="12" class="py-0">
                <div class="body-1 descreption position-relative px-2 secondary--text">
                  {{ blog.description }}
                  {{ blog.description }}
                  {{ blog.description }}
                  {{ blog.description }}
                  {{ blog.description }}
                  {{ blog.description }}
                  {{ blog.description }}
                </div>
              </v-col>
              <v-col cols="12">
                <v-btn depressed @click="$router.push(`/blogs/${blog.title}/${blog.id}`)" color="primary"
                  class="d-block mi-start-auto rounded-lg">
                  {{ $t('read more') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

      </v-row>

      <v-divider class="my-5"></v-divider>

       <!-- Comments -->

      <v-row justify="center" justify-lg="space-between">

        <v-col cols="12" md="6" xl="5">
          <v-card class="light shadow-none  pa-5">
            <div class="text-h6 font-weight-bold mx-2">
              {{ $t('comments') | capitalize }}
            </div>
            <GenericInput type="textarea" background-color="white" placeholder="write a comment.." name="comment"
              :value="comment" @input="comment = $event" :required="true" :isLoading="false" :cols="[12, 12, 12]">
            </GenericInput>
            <v-col cols="12">
              <v-btn color="primary" class="d-block rounded-lg mi-start-auto" depressed>
                {{$t('post your comment')}}
              </v-btn>
            </v-col>
          </v-card>
        </v-col>

        <!-- Users Comments -->
        <v-col cols="12" md="6" xl="5">
          <v-card class=" shadow-none  pa-5">
            <div class="text-h6 font-weight-bold mx-2">
              {{ $t('user comments') | capitalize }} <small class="gray8--text">({{comments.length}} {{$t('comments') | capitalize}})</small>
            </div>
            
            <template v-if="comments.length > 0">
              <v-card class="shadow-none d-flex align-center justify-center  mt-2"
                v-for="(comment, index) in comments" :key="index">
                <!-- <v-avatar size="35" class="rounded-circle ">
                  <v-img v-if="comment.user_image" :src="$store.state.endpointURL + comment.user_image" alt="" />
                  <v-img v-else src="@/assets/img/svg/userAvatar.svg" alt="" />
                </v-avatar> -->
                <v-card-title class="subtitle-2  font-weight-bold">
                  <div>
                    {{ comment.username }} <span class="mx-1 font-weight-medium gray8--text"><small>{{
                        comment.add_date | dateEn
                    }}</small></span>
                  </div>
                  <v-card-text class="subtitle-2 gray6--text pa-0">{{ comment.comment }} </v-card-text>
                </v-card-title>
              </v-card>
            </template>
            <div v-else class="text-center text-h6 gray7--text">
              {{ $t('no comment found') | capitalize }} 🙁
            </div>

          </v-card>
        </v-col>
      </v-row>

    </v-container>





  </v-container>
</template>

<script>
import GenericInput from '@/components/ui/GenericInput.vue';



export default {
  name: "BlogPage",

  components: {
    GenericInput
  },

  data: () => ({
    data: null,
    title: 'blog',
    metaTitle: null,
    metaDescription: null,

    blog: {
      "id": 1,
      "title": "أحدث الطرق لعلاج الصلع الوراثي للرجال",
      "description": "لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي  لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومنعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن  عة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن عة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن عة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي  لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي :",
      "image": "/upload/blogs_images/43584b2a-6ea6-4ec3-a90b-68948d40f0a2.jpeg",
      "blog_active": 1,
      "add_date": "2022-11-17 13:33:34",
      "add_user": 1,
      "added_by": "Admin",
      "blog_comments_count": 3,
      "blog_comments": [
        {
          "id": 1,
          "blog_id": 1,
          "comment": "تيست",
          "user_id": 1,
          "user_full_name": "Admin",
          "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
          "add_date": "2022-11-17 13:42:19"
        },
        {
          "id": 2,
          "blog_id": 1,
          "comment": "تيست",
          "user_id": 1,
          "user_full_name": "Admin",
          "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
          "add_date": "2022-11-17 13:42:19"
        },
        {
          "id": 3,
          "blog_id": 1,
          "comment": "تيست",
          "user_id": 1,
          "user_full_name": "Admin",
          "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
          "add_date": "2022-11-17 13:42:30"
        }
      ]
    },
    blogs: [
      {
        "id": 1,
        "title": "أحدث الطرق لعلاج الصلع الوراثي للرجال",
        "description": "لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي:",
        "image": "/upload/blogs_images/43584b2a-6ea6-4ec3-a90b-68948d40f0a2.jpeg",
        "blog_active": 1,
        "add_date": "2022-11-17 13:33:34",
        "add_user": 1,
        "added_by": "Admin",
        "blog_comments_count": 3,
        "blog_comments": [
          {
            "id": 1,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 2,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 3,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:30"
          }
        ]
      },
      {
        "id": 1,
        "title": "أحدث الطرق لعلاج الصلع الوراثي للرجال",
        "description": "لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي:",
        "image": "/upload/blogs_images/43584b2a-6ea6-4ec3-a90b-68948d40f0a2.jpeg",
        "blog_active": 1,
        "add_date": "2022-11-17 13:33:34",
        "add_user": 1,
        "added_by": "Admin",
        "blog_comments_count": 3,
        "blog_comments": [
          {
            "id": 1,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 2,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 3,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:30"
          }
        ]
      },
      {
        "id": 1,
        "title": "أحدث الطرق لعلاج الصلع الوراثي للرجال",
        "description": "لعلاج الصلع عند الرجال بالأدويةتوجد مجموعة من الأدوية التي أثبتت فعاليتها في علاج الصلع، ومن أبرزها الآتي:",
        "image": "/upload/blogs_images/43584b2a-6ea6-4ec3-a90b-68948d40f0a2.jpeg",
        "blog_active": 1,
        "add_date": "2022-11-17 13:33:34",
        "add_user": 1,
        "added_by": "Admin",
        "blog_comments_count": 3,
        "blog_comments": [
          {
            "id": 1,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 2,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:19"
          },
          {
            "id": 3,
            "blog_id": 1,
            "comment": "تيست",
            "user_id": 1,
            "user_full_name": "Admin",
            "user_image": "/upload/users_images/57037f5d-4f93-4d2f-b2b4-c4c10bd0ad8e.jpeg",
            "add_date": "2022-11-17 13:42:30"
          }
        ]
      },

    ],
    comment: null,
    comments : [
      {
        id : 1,
        add_date : '2022-12-01',
        username : 'احمد صابر',
        user_image : null,
        comment : '2. الأدوية التي تمنع إنتاج هرمون ديهدرو - تيستوستيرون الأدوية التي تمنع إنتاج هرمون ديهدرو - تيستوستيرون مثال عليها دواء الفيناستريد (Finasteride).'
      },
      {
        id : 2,
        add_date : '2022-12-01',
        username : 'مصطفي جميل',
        user_image : null,
        comment : '2. الأدوية التي تمنع إنتاج هرمون ديهدرو - تيستوستيرون الأدوية التي تمنع إنتاج هرمون ديهدرو - تيستوستيرون مثال عليها دواء الفيناستريد (Finasteride).'
      }
    ],
  }),
  head() {
    return {
      title: this.$route.params.blog,

    }
  },
  mounted() {
    // this.getData()

  },
  watch: {
    $route() {

    },
  },
  methods: {
    // getData() {
    //   this.$store.state.splashScreen = true;
    //   this.$api.GET_METHOD(`home`).then((response) => {
    //     this.$store.state.splashScreen = false;
    //     if (response.check) {
    //       this.$store.commit("SET_DEFAULTS_DATA", response.data);
    //     }
    //   })
    // },

  },

}
</script>
<style lang="scss" scoped>
.product-banner {
  height: 250px;
  position: relative;
  overflow-x: hidden;
  background-image: url('../../../assets/img/svg/landing-section.svg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  color: var(--white);

  display: flex;
  align-items: center;
}

.blog-card {
  .title {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0 1rem;
    transition: .3s;
  }

  .descreption {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 0 3rem;
    transition: .3s;
  }
}
</style>